<template>
  <div class="">
    <div class="row">
      <div class="col">
        <div class="alert alert-primary group-title">
          <icon :icon="['fad', 'search-location']"/>
          Institution search
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label font-weight-bold p-0">
          Search your place with Google
        </label>
        <input type="text" name="name" autocomplete="on" class="form-control" v-model="query">
        <!--    <button class="btn btn-danger" v-on:click="doSearch">do search</button>-->
        <!--    {{searchResult}}-->
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: "GooglePlaces",
    data() {
      return {
        key: "",
        url: "https://maps.googleapis.com/maps/api/place/findplacefromtext/json?inputtype=textquery&fields=formatted_address,name&key=AIzaSyDLQu76drNqGa_UxE1BWgGvOSaMlt_vUao&input=",
        query: '',
        searchResult: null
      };
    },
    methods: {
      doSearch() {
        let url
        var app = this
        axios.get(this.url + encodeURI(this.query), {
          headers: {
            'Access-Control-Allow-Origin': '*',
          },
        }).then(function (response) {
          app.searchResult = response.data;
          console.log(app.searchResult);
        })
            .catch(function (error) {
              console.log(error);
            })
      }
    }
  }
</script>

<style scoped>

</style>
